import ExpenseSVG1 from "../assets/expense_management/stress_free_invoicing.svg";
import ExpenseSVG2 from "../assets/expense_management/effortless_tracking_and_reporting.svg";
import ExpenseSVG3 from "../assets/expense_management/flexible_payment_options.svg";
import ExpenseSVG4 from "../assets/expense_management/Trip_approval_system.svg";

export const EXPENSE_MANAGEMENT_TABS = [
    {
        title: `Automated invoicing`,
        subPara: `Stress-free Invoicing is here. Get customized invoices on your due date and make payments on the spot.`,
        svg: ExpenseSVG1
    },
    {
        title: `Seamless payment options`,
        subPara: `We offer flexible payment options, so you can plan your business trips on the go and pay the way you prefer.`,
        svg: ExpenseSVG3
    },
    {
        title: `Real-time visibility`,
        subPara: `Make trip expense tracking and reporting effortless for your business.`,
        svg: ExpenseSVG2
    },
    {
        title: `Centralized trip approval system`,
        subPara: `Simplify and streamline your business trip process in just a few clicks.`,
        svg: ExpenseSVG4
    },
];